export const LOAD_USER_COMPANY_RULES = 'LOAD_USER_COMPANY_RULES'
export const CHANGE_SIDEBAR_PINNED = 'CHANGE_SIDEBAR_PINNED'
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const SET_ACTIVE_COMPANY_DATA = 'SET_ACTIVE_COMPANY_DATA'
export const SET_CURRENT_LOCALE = 'SET_CURRENT_LOCALE'
export const LOAD_USER_DATA = 'LOAD_USER_DATA'
export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const UPDATE_TOKENS = 'UPDATE_TOKENS'
export const SET_ACTIVE_COMPANY = 'SET_ACTIVE_COMPANY'
export const SET_ACTIVE_COMPANY_DATA_LOADING = 'SET_ACTIVE_COMPANY_DATA_LOADING'
export const ADD_EXPORT = 'ADD_EXPORT'
export const SET_WSS_CONNECTION = 'SET_WSS_CONNECTION'
export const SUBSCRIBE_TO_REPORT_CHANNEL = 'SUBSCRIBE_TO_REPORT_CHANNEL'
export const SUBSCRIBED_TO_WSS_CHANNEL = 'SUBSCRIBED_TO_WSS_CHANNEL'
export const UPDATE_EXPORT_ITEM = 'UPDATE_EXPORT_ITEM'
export const HANDLE_EXPORT_WS_MESSAGE = 'HANDLE_EXPORT_WS_MESSAGE'
export const SET_ACTIVE_EXPORTS = 'SET_ACTIVE_EXPORTS'
export const EXPORT_DOWNLOADED = 'EXPORT_DOWNLOADED'
export const LOAD_COMPANY = 'LOAD_COMPANY'
export const SYNC_EXPORTS = 'SYNC_EXPORTS'
export const RESET_PASSWORD_STEP = 'RESET_PASSWORD_STEP' // NOSONAR
export const CLEAR_EXPORT_QUEUE = 'CLEAR_EXPORT_QUEUE'

export const SET_SHOW_FILTERS = 'SET_SHOW_FILTERS'
export const SET_XPAY_OPERATION_ID = 'SET_XPAY_OPERATION_ID'
export const SET_XPAY_OPERATION_TYPE = 'SET_XPAY_OPERATION_TYPE'

export const INITIALIZE_AUTH = 'INITIALIZE_AUTH'
